<!-- Hiển thị thông tin nhân viên chỉ có avatar - dvquang2 15/10/2021-->
<template>
  <div class="display-employee2 flex items-center">
    <div
      v-for="(employee,index) in listEmployee"
      :key="employee.UserID"
      class="display-employee2-container flex items-center"
    >
      <ms-tooltip>
        <div
          v-if="index < 5"
          :style="index == 0 ? `margin-left:0px` : `margin-left:-6px`"
        >
          <img
            :src="employee.AvatarSource"
            class="display-employee2-avatar"
          >
        </div>
        <template #text>
          <div class="flex items-center">
            <div>{{ employee.FullName }}</div>
            <div v-if="employee.OfficeEmail">
              &nbsp;{{ "(" + employee.OfficeEmail + ")" }}
            </div>
            <div v-else>
              &nbsp;{{ "(" + employee.Email + ")" }}
            </div>
          </div>
          <DisplayEmployeeDetail
            style="text-align: left"
            :employee="getEmployeeDetailParam(employee)"
          />
        </template>
      </ms-tooltip>
    </div>
    <ms-tooltip>
      <div
        v-if="listEmployee.length > 5"
        class="display-employee2-hidden"
        @mouseenter="openPopoverHidden($event)"
        @mouseleave="hidePopoverHidden"
      >
        <div
          v-if="listEmployeeHidden.length < 10"
          class="display-employee2-number"
        >
          {{ "+" }}{{ listEmployee.length - 5 }}
        </div>
        <div
          v-if="listEmployeeHidden.length > 9"
          class="display-employee2-number"
        >
          9+
        </div>
      </div>

      <template #text>
        <DxScrollView class="popover-display-employee-only-avatar">
          <display-employee
            :style="{'text-align':'left'}"
            :list-employee="listEmployeeHidden"
            :is-display-btn-delete="false"
          />
        </DxScrollView>
      </template>
    </ms-tooltip>
  </div>
  </div>
</template>

<script>
import AvatarService from "@/apis/base/avatar/AvatarService.js";
import MsTooltip from "../ms-tooltip/MsTooltip.vue";
import MsTooltip2 from "../ms-tooltip/MsTooltip2.vue";
import MsPopover from "../ms-popover/MsPopover.vue";
import DisplayEmployee from "./DisplayEmployee.vue";
import DisplayEmployeeDetail from "./DisplayEmployeeDetail.vue";
import { DxScrollView } from "devextreme-vue/scroll-view";

export default {
  name: "DisplayEmployeeOnlyAvatar",
  components: {
    MsTooltip,
    MsPopover,
    DisplayEmployee,
    DisplayEmployeeDetail,
    DxScrollView,
  },
  props: {
    listEmployee: {
      type: Array,
      default: () => [],
    },
    isAcceptOpenHidden: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // ẩn hiện popup hiển thị danh sách người bị ẩn
      visiblePopoverDE2: false,
      listEmployeeHidden: [],
      targetPopover: "",
    };
  },
  watch: {
    listEmployee: {
      immediate: true,
      // watch đầu vào nếu thay đổi thì caall cập nhật giao diện
      handler(val, oldVal) {
        if (val) {
          //this.buildAvatarUrl(val);
          this.checkHiddenPeople(val);
        }
      },
    },
  },
  created() {
    this.buildAvatarUrl(this.listEmployee);
    this.checkHiddenPeople(this.listEmployee);
  },
  methods: {
    getEmployeeDetailParam(employee) {
      return {
        JobTitleName: employee.JobTitleName,
        OrganizationUnitName: employee.OrganizationUnitName,
        OrganizationName: employee.OrganizationName,
      };
    },
    /**
     * lấy link avatar và gán index để hiển thị control này
     * dvquang2 15.10.2021
     */
    buildAvatarUrl(listEmployee) {
      try {
        const me = this;
        listEmployee.forEach((element, index) => {
          element.AvatarSource = AvatarService.getAvatar(element.MISAID);
          element.indexClient = index;
        });
      } catch (error) {}
    },

    /**
     * check số người cần ẩn nếu số người đầu vào > 5
     * dvquang2 15/10/2021
     */
    checkHiddenPeople() {
      if (this.listEmployee.length > 5) {
        const listEmployeeClone = this.$function._cloneDeep(this.listEmployee);
        listEmployeeClone.splice(0, 5);
        this.listEmployeeHidden = listEmployeeClone;
      }
    },

    openPopoverHidden(event) {
      if (this.isAcceptOpenHidden) {
        this.visiblePopoverDE2 = true;
        this.targetPopover = event.target;
      }
    },

    hidePopoverHidden() {
      this.visiblePopoverDE2 = false;
    },
    closePopover() {
      this.visiblePopoverDE2 = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.display-employee2-avatar {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid #ffff;
}
.display-employee2 {
}
.display-employee2-hidden {
  width: 28px;
  height: 28px;
  margin-bottom: 5px;
  background-color: #616767;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.display-employee2-number {
  color: #ffffff;
}
.display-employee2-content-hidden {
  height: 48px;
  display: flex;
  /* justify-content: center; */
  align-items: center;
}
.popover-display-employee-only-avatar {
  max-height: 360px !important;
  min-height: 52px !important;
  width: 400px !important;
}
</style>
